import { getFirestore, collection, addDoc, doc, updateDoc, increment, serverTimestamp } from "firebase/firestore";

export const AudioTrackService = {

    submitUpvote: async (trackId: string, collectionName: string = "tracks") => {
        const db = getFirestore();

        try {
            const voteRef = await addDoc(collection(db, "trackUpvotes"), {
                trackId: trackId,
                dateUpvoted: serverTimestamp(),
            });

            const trackRef = doc(db, collectionName, trackId);
            await updateDoc(trackRef, {
                voteCount: increment(1)
            });

            console.log("Upvote recorded with ID: ", voteRef.id);
            return true;
        } catch (error) {
            console.error("Error submitting upvote: ", error);
            return false;
        }
    }
};